module.exports = __webpack_public_path__ + "img/other.4bc64488.png";